import { makeStyles } from '@material-ui/core/styles'
import { useEffect, useState } from 'react'
import { reExportedColors, ITooltip } from '../../../1elements'
import CloseIcon from '@mui/icons-material/Close'
import Checkbox from '@mui/material/Checkbox'
import { texts } from '../../../../consts/Texts'
import IconButton from '@mui/material/IconButton'
import FilterIcon from '../../../1elements/Icons/js/icons/FilterIcon'
import React from 'react'
import { useSelector } from '../../../../common/redux.Interface.Component'

const LocationListView = ({ mock }) => {
  const accountDetail = useSelector(state => state.tabs.accountDetail)
  const classes = useStyles()
  const [currentPosts, setCurrentPosts] = useState([])
  const [postsPerPage] = useState(50)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPosts] = useState(0)
  const [filterTable, setFilterTable] = useState(false)
  const handleShow = () => {
    if (filterTable) {
      setFilterTable(false)
    } else {
      setFilterTable(true)
    }
  }
  const [buildingName, setBuildingName] = useState(true)
  const [transitid, setTransitId] = useState(true)
  const [transitName, setTransitName] = useState(true)
  const [city, setCity] = useState(true)
  const [sqFt, setSqft] = useState(true)
  const [Province, setProvince] = useState(true)

  const jumpLocation = id => {
    localStorage.setItem('locId', id)
  }
  const paginate = pageNumber => {
    setCurrentPage(pageNumber)
  }
  const pageNumbers = []
  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pageNumbers.push(i)
  }
  const allSelector = () => {
    setBuildingName(true)
    setTransitId(true)
    setCity(true)
    setProvince(true)
    setSqft(true)
    setTransitName(true)
  }

  const emptyData = Array(10)
    .fill()
    .map(() => ({
      bec_building_id: '',
      transit_id: '',
      city: '',
      state: '',
      size: null
    }))

  const getLocationsByAccountID = async () => {
    setCurrentPosts(accountDetail.locations)
  }

  useEffect(() => {
    if (mock) {
      setCurrentPosts(emptyData)
    } else {
      getLocationsByAccountID()
    }
    // XXX Fix this in the future
    // eslint-disable-next-line
  }, [])

  return (
    <React.Fragment>
      <div className={classes.locationDiv}>
        <ITooltip placement='top' content='Filter'>
          <IconButton
            onClick={handleShow}
            className={filterTable ? classes.menuBartwo : classes.menuBar}
            disabled={mock}
          >
            <FilterIcon />
          </IconButton>
        </ITooltip>
      </div>
      {filterTable && (
        <div className={classes.list}>
          <div className={classes.option}>
            <div className={classes.checkDiv}>
              <div className={classes.checkAllop}>
                <div
                  className={classes.selectOp}
                  onClick={() => {
                    allSelector()
                  }}
                >
                  Select All{' '}
                </div>
                <CloseIcon className={classes.close} onClick={handleShow} />
              </div>
            </div>
            <div className={classes.checkDiv}>
              <Checkbox
                checked={buildingName}
                color='default'
                onChange={() => {
                  buildingName ? setBuildingName(false) : setBuildingName(true)
                }}
              />
              <span className={classes.checkOption}>Building ID</span>
            </div>

            <div className={classes.checkDiv}>
              <Checkbox
                checked={transitid}
                color='default'
                onChange={() => {
                  transitid ? setTransitId(false) : setTransitId(true)
                }}
              />
              <span>{texts.transitId}</span>
            </div>
            <div className={classes.checkDiv}>
              <Checkbox
                checked={transitName}
                color='default'
                onChange={() => {
                  transitName ? setTransitName(false) : setTransitName(true)
                }}
              />
              <span>Location Name</span>
            </div>
            <div className={classes.checkDiv}>
              <Checkbox
                checked={city}
                color='default'
                onChange={() => {
                  city ? setCity(false) : setCity(true)
                }}
              />
              <span>City</span>
            </div>

            <div className={classes.checkDiv}>
              <Checkbox
                checked={Province}
                color='default'
                onChange={() => {
                  Province ? setProvince(false) : setProvince(true)
                }}
              />
              <span>Province</span>
            </div>
            <div className={classes.checkDiv}>
              <Checkbox
                checked={sqFt}
                color='default'
                onChange={() => {
                  Province ? setSqft(false) : setSqft(true)
                }}
              />
              <span>Sq.ft</span>
            </div>
          </div>
        </div>
      )}
      <div className={classes.table}>
        <div className={classes.TableRootTwo}>
          <div className={classes.Table}>
            <div className={classes.TableHeaderRow}>
              {buildingName ? (
                <div className={classes.TableHeader}>
                  <ITooltip placement='top' content='Sort'>
                    <div className={classes.HoverDiv}>Building ID</div>
                  </ITooltip>
                </div>
              ) : null}

              {transitid ? (
                <div className={classes.TableHeader}>
                  <ITooltip placement='top' content='Sort'>
                    <div className={classes.HoverDiv}>{texts.transitId}</div>
                  </ITooltip>
                </div>
              ) : null}

              {city ? (
                <div className={classes.TableHeader}>
                  <ITooltip placement='top' content='Sort'>
                    <div className={classes.HoverDiv}>City</div>
                  </ITooltip>
                </div>
              ) : null}

              {Province ? (
                <div className={classes.TableHeader}>
                  <ITooltip placement='top' content='Sort'>
                    <div className={classes.HoverDiv}>Province</div>
                  </ITooltip>
                </div>
              ) : null}

              {sqFt ? (
                <div className={classes.TableHeader}>
                  <ITooltip placement='top' content='Sort'>
                    <div
                      className={`${classes.HoverDiv} ${classes.numberHeader}`}
                    >
                      Sq.ft
                    </div>
                  </ITooltip>
                </div>
              ) : null}
            </div>
            <div className={classes.tableBody}>
              {currentPosts?.map((items, i) => (
                <div
                  key={i}
                  className={classes.TableDataRow}
                  onClick={() => {
                    jumpLocation(items.id)
                  }}
                >
                  {buildingName ? (
                    <div className={classes.TableData}>
                      {items.bec_building_id}
                    </div>
                  ) : null}
                  {transitid ? (
                    <div className={classes.TableData}>{items.transit_id}</div>
                  ) : null}
                  {city ? (
                    <div className={classes.TableData}>{items.city}</div>
                  ) : null}
                  {Province ? (
                    <div className={classes.TableData}>{items.state}</div>
                  ) : null}
                  {sqFt ? (
                    <div className={`${classes.TableData} ${classes.number}`}>
                      {(function (x) {
                        if (x !== 'null') {
                          return Math.round(parseInt(x))
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                      })(`${items.size}`)}
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={classes.paginationConatiner}>
          <nav className={classes.Pageroot}>
            <ul className={classes.pagination}>
              {pageNumbers.map(number => (
                <li key={number} className={classes.pagelist}>
                  <button
                    className={
                      number === currentPage
                        ? classes.pageDivSelected
                        : classes.PageDiv
                    }
                    onClick={() => paginate(number)}
                  >
                    {number}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

export default LocationListView

const useStyles = makeStyles(theme => ({
  tableBody: {
    height: '100%',
    width: '100%',
    maxHeight: 200,
    overflowY: 'auto'
  },
  accountC1: {
    position: 'absolute',
    left: '10px',
    fontSize: '15px'
  },
  accountTable: {
    fontFamily: 'lato',
    borderCollapse: 'collapse',
    width: '100%',
    border: '1px solid #ddd',
    padding: '8px',
    marginLeft: '10px',
    marginBottom: '4px'
  },
  td: {
    border: '1px solid #ddd',
    fontFamily: 'Lato',
    fontSize: '13px',
    padding: ' 2px',
    backgroundColor: '#EAEAEA',
    // textAlign: 'center',
    '&:hover': {
      background: '#DBDBDB'
    }
  },
  th: {
    border: '#5F5F5F 0% 0% no-repeat padding-box',
    padding: '2px',
    backgroundColor: '#5F5F5F',
    fontSize: '13px',
    fontFamily: 'Roboto',
    color: 'white', ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    cursor: 'pointer',
    '&:hover': {
      background: '#DBDBDB'
    }
  },
  accData: {
    fontSize: '12px',
    display: 'flex',
    fontFamily: 'Roboto',
    marginLeft: '30px',
    marginTop: '0px'
  },
  accInfo: {
    display: 'flex'
  },
  acc: {
    fontWeight: 'bold'
  },

  pageStyle: {
    marginRight: '100px'
  },
  arrow: {
    display: 'flex',
    margin: '1px',
    justifyContent: 'space-between'
  },
  pageNo: {
    display: 'flex',
    alignItems: 'center'
  },
  pagination: {
    right: '100px',
    display: 'flex'
  },
  menuBar: {
    height: 30,
    width: 30,
    cursor: 'Pointer',
    padding: '4px',
    borderRadius: '4px',
    '&:hover': {
      background: 'none !important',
      height: 30,
      width: 30,
      '& *': {
        stroke: theme.palette.primary.accent
      }
    }
  },
  menuBartwo: {
    height: 30,
    width: 30,
    cursor: 'Pointer',
    padding: '4px',
    background: theme.palette.primary.accent,
    borderRadius: '4px'
  },
  accord: {
    marginBottom: '0',
    backgroundColor: ' rgba(0,0,0,.03)', ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    borderBottom: '1px solid rgba(0,0,0,.125)' ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  option: {
    right: '20px'
  },
  list: {
    right: 0,
    top: 85,
    position: 'absolute',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    borderRadius: '6px',
    zIndex: '90',
    paddingBottom: '15px',
    paddingRight: '20px',
    paddingLeft: '10px',
    fontFamily: 'Roboto',
    boxShadow: '0px 0px 5px #00000029',
    minWidth: '166px'
  },
  mobileuser: {
    height: 'inherit',
    paddingLeft: 14,
    width: '100%'
  },
  head: {
    marginTop: '15px',
    marginBottom: '8px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  HeadName: {
    fontSize: '22px',
    fontWeight: '600'
  },
  Mobilehead: {
    marginTop: '70px',
    marginLeft: '10px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
    width: '480px'
  },
  TableRoot: {
    height: '100%',
    overflow: 'auto'
  },
  TableRootTwo: {
    overflow: 'auto'
  },
  Table: {
    width: '100%',
    borderCollapse: 'collapse',
    borderSpacing: '8px',
    display: 'table'
  },
  MobileTableRoot: {
    width: '450px'
  },
  TableHeaderRow: {
    background: theme.palette.secondary.accent,
    height: '42px',
    color: 'white', ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    position: 'sticky',
    top: 0,
    borderRadius: '4px',
    fontFamily: 'Roboto, sans-serif',
    width: '100%',
    paddingRight: 10
  },
  TableHeader: {
    flexBasis: '140px',
    fontSize: '13px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'center',
    flexGrow: 1,
    '& *': {
      textAlign: 'center'
    },
    '&:last-child': {
      justifyContent: 'flex-end'
    }
  },
  tableHeaderArea: {
    paddingLeft: '20px',
    justifyContent: 'center'
  },
  HoverDiv: {
    alignItems: 'center',
    display: 'flex',
    '&:hover': {
      background: reExportedColors.MEDIUM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
      borderRadius: '4px'
    },
    cursor: 'pointer'
  },
  TableHeaderIcon: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '-5px'
  },
  UpIcon: {
    marginBottom: '-17px'
  },
  UpIconAfter: {
    marginBottom: '-17px',
    color: reExportedColors.MEDIUM_GREY ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  DownIcon: {
    marginTop: '-1px',
    color: reExportedColors.MEDIUM_GREY ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  DownIconAfter: {
    marginTop: '-1px'
  },
  TableDataRow: {
    width: '100%',
    background: '#F7F7F7',
    height: '40px',
    maxHeight: '36px',
    lineHeight: '12px',
    color: 'black',
    fontSize: '11px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: '4px',
    fontFamily: 'Roboto, sans-serif',
    cursor: 'pointer',
    '&:hover': {
      background: '#EAEAEA'
    }
  },
  TableData: {
    width: '145px',
    padding: '4px',
    textAlign: 'center',
    fontSize: '13px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: '8px',
    fontFamily: 'Roboto, sans-serif',
    flexGrow: 2,
    borderRight: '1px solid #C7C9CB',
    '&:last-child': {
      border: 'none'
    }
  },
  timeString: {
    paddingLeft: '2px',
    marginLeft: '2px',
    marginRight: '2px'
  },
  paginationConatiner: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  Pageroot: {
    width: 'fit-content',
    height: '30px',
    padding: '4px',
    display: 'flex'
  },
  pagelist: {
    marginLeft: '4px',
    marginRight: '4px',
    cursor: 'pointer',
    fontSize: '13px',
    display: 'flex',
    justifyContent: 'center',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  PageDiv: {
    display: 'flex',
    justifyContent: 'center',
    color: 'black',
    border: 'none',
    background: 'none'
  },
  PageCount: {
    fontSize: '12px',
    fontWeight: 'bold'
  },
  pageDivSelected: {
    fontWeight: 'bold',
    border: 'none',
    background: 'none'
  },
  locationDiv: {
    margin: '10px 0',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  check: {
    display: 'flex'
  },
  checkOption: {
    fontSize: '12px',
    fontWeight: '50px'
  },
  checkDiv: {
    height: '25px',
    fontSize: '12px',
    marginLeft: '-7px',
    marginBottom: '1px'
  },
  close: {
    width: 18,
    height: 18,
    cursor: 'pointer',
    marginRight: '5px'
  },
  checkAllop: {
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: '15px',
    alignItems: 'center',
    marginTop: '10px',
    width: '100%'
  },
  selectOp: {
    fontSize: 12,
    fontFamily: 'roboto',
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  loderDiv: {
    marginTop: '15%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Roboto'
  },

  TableHeader2: {
    width: '200px',
    paddingLeft: '8px',
    margin: '4px',
    textAlign: 'start',
    fontSize: '13px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  TableHeaderIcon2: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '-5px'
  },
  TableData2: {
    width: '200px',
    margin: '4px',
    textAlign: 'start',
    fontSize: '13px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: '8px'
  },
  number: {
    textAlign: 'right',
    paddingRight: '70px'
  },
  numberHeader: {
    paddingRight: '75px'
  },
  widerColumn: {
    flexGrow: 2,
    maxWidth: '400px'
  },
  accHead: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    width: 'auto'
  },
  editModeButton: {
    position: 'absolute',
    right: 40,
    top: 7
  },
  buttonDiv: {
    display: 'flex',
    justifyContent: 'flex-end',

    '& button': {
      margin: '0 5px'
    }
  }
}))
